import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { ISummaryStatistics } from "../domain/ISummaryStatistics";
import { IYearRequestParams } from "../domain/IYearRequestParams";
import { StatisticsService } from "../services/statistics.service";

interface SummaryStatisticsState {
    loading: boolean;
    statistics?: ISummaryStatistics;
    error: any;
}

const initialState: SummaryStatisticsState = {
    loading: false,
    statistics: undefined,
    error: undefined
}

export const getSummaryStatistics = createAsyncThunk(
    "Statistics/getSummaryStatistics",
    async(year?: IYearRequestParams) => {
        try {
            const result = await StatisticsService.getSummaryStatistics(year);
            return result;
        } catch (err){
            setError(err);
        }
    }
);

export const SummaryStatisticsSlice = createSlice({
    name: "SummaryStatistics",
    initialState: initialState,
    reducers: {
        setStatistics: (state, action: PayloadAction<ISummaryStatistics>) => {
            state.statistics = action.payload;
        },
        setError: (state, action: PayloadAction<any>)  => {
            state.error = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getSummaryStatistics.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getSummaryStatistics.fulfilled, (state, action) => {
            state.loading = false;
            state.statistics = action.payload ? action.payload : undefined;
        });
        builder.addCase(getSummaryStatistics.rejected, (state,action) => {
            state.loading = false;
            state.error = action.error;
        });
    }
})

export const selectState = (state: RootState) => state.statistics.summary;

export const { setError } = SummaryStatisticsSlice.actions;

export default SummaryStatisticsSlice.reducer